import script from "./DueDateCompo.vue?vue&type=script&setup=true&lang=js"
export * from "./DueDateCompo.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&lang=css&external"
import "./DueDateCompo.vue?vue&type=style&index=1&id=1dbb40bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dbb40bc"]])

export default __exports__